import { createRootRoute, Outlet } from '@tanstack/react-router';
import { AppWrapper } from 'components/App/style/App.style';
import PendingSessionsModalWrapper from 'components/PendingSessionsModalWrapper/PendingSessionsModalWrapper.component';
import VivochaHelpCenterContainer from 'components/vivocha';
import { APP_VENDOR } from 'config';
import { NotFoundPage } from 'pages/not-found-page';
import React, { Suspense } from 'react';
import { useScrollToTopOnPathnameChange } from 'routers/routers.hooks';
import { useUpdateInboxStats } from 'services/inbox/inbox.hooks';

import { useUpdateUserBalance } from 'services/user/user.hooks';

const TanStackRouterDevtools = import.meta.env.PROD
  ? () => null // Render nothing in production
  : React.lazy(() =>
      // Lazy load in development
      import('@tanstack/react-router-devtools').then((res) => ({
        default: res.TanStackRouterDevtools,
      })),
    );

export const Route = createRootRoute({
  notFoundComponent: NotFoundPage,
  component: function RootRoute() {
    useUpdateInboxStats();
    useUpdateUserBalance();
    useScrollToTopOnPathnameChange();

    return (
      <AppWrapper className={`${APP_VENDOR}-theme`}>
        <PendingSessionsModalWrapper />
        <Outlet />
        <Suspense>
          <TanStackRouterDevtools />
        </Suspense>
        <VivochaHelpCenterContainer />
      </AppWrapper>
    );
  },
});
